import { render, staticRenderFns } from "./TextResizable.vue?vue&type=template&id=16663b5a"
import script from "./TextResizable.vue?vue&type=script&lang=js"
export * from "./TextResizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports